<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="row">
        <HeaderComp currentPage="chapter"></HeaderComp>

        <SouthAfricaChapterContent class="text-black" />

        <FooterComp></FooterComp>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import HeaderComp from '@/components/layouts/HeaderComp'
import FooterComp from '@/components/layouts/FooterComp'
import SouthAfricaChapterContent from '@/views/content/chapters/SouthAfricaChapterContent'
export default {
  components: { SouthAfricaChapterContent, FooterComp, HeaderComp },

  data() {
    return {}
  },
}
</script>
